import Icon from "@material-ui/icons/Person";
import ScheduleCreate from "./ScheduleCreate";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "studentSchedules",
  create: ScheduleCreate,
  icon: Icon,
};
